// extracted by css-extract-rspack-plugin
export default {"paymentLabel":"footer-fragment__PaymentPill_paymentLabel__uWWrn","paymentImg":"footer-fragment__PaymentPill_paymentImg__80T76"};